import { Adapter } from './adapter';
import { Certificate } from '../models/certifications.model';
import { KeplerCredlyBadge } from '@app/interfaces/kepler-credly.interface';

/**
 * Adapt raw service certificate object to Certificate model
 * NOTE: The item fields are the default json property names.
 */
export class CertificateAdapter implements Adapter<Certificate> {
  /**
   * Adapt data item into a Certificate model.
   * @param item - data item KeplerCredlyBadge to be transformed
   * @returns - returns an adapted Certificate model
   */
  adapt(item: KeplerCredlyBadge): Certificate {
    let certificate: Certificate;
    if (item) {
      const image = item.image.url;
      const title = item.badge_template.name;
      const level = item.badge_template.level;
      const expires = item.expires_at ? new Date(item.expires_at).toISOString().split('T')[0] : '';
      const url = item.badge_url;
      const expiredFlag = new Date(item.expires_at) < new Date();
      const expiryDueDate = item.expires_at ? new Date(item.expires_at).getTime() : undefined;
      certificate = new Certificate(image, title, level, expires, url, expiredFlag, expiryDueDate);
    }
    return certificate;
  }
}
